<template>
  <div>
    <fields-list :fields="fields" :item="item" />
  </div>
</template>
<script>
/**Меняю добавление модалку */

import { multiKeyInit } from "../../plugins/functions";
import FieldsList from "./FieldsList";

export default {
  props: {
    value: {
      default: function () {
        return {};
      },
    },
    subFields: {
      default: function () {
        return [
          {
            key: "body",
            label: "Название",
            type: "html",
            textType: "text",
            isMultiLang: true,
          },
        ];
      },
    },
  },
  data: () => ({
    fields: [],
    item: {},
  }),
  methods: {
    multiKeyInit: multiKeyInit,
  },
  components: {
    FieldsList,
  },
  async created() {
   this.fields = this.subFields;
   this.item = await this.multiKeyInit(this.value, this, 0);
  },
};
</script>

